export default {
  wrapper: {
    base: {
      backgroundColor: 'grey-0'
    }
  },
  close: {
    base: {
      color: 'uswitch-navy'
    }
  },
  title: {
    base: {
      color: 'uswitch-navy',
      fontFamily: 'heading',
      lineHeight: ['1.2', '1.2', 'sm'],
      fontWeight: 'xxbold',
      marginBottom: '14px'
    }
  },
  content: {
    base: {
      color: 'grey-60',
      fontSize: ['base', 'base', 'sm'],
      lineHeight: ['base', 'base', 'xl']
    }
  }
};